import { DOMAIN_COUNTRY_MAP } from '@/src/constants/domain'

export interface SupportContacts {
    local_calls: string
    international_calls: string
    whatsapp: string
    email: string
}

interface SupportConfig {
    brand: 'Flyin' | 'Cleartrip'
    domain: 'EG' | 'AE' | 'FSA'
    contacts: SupportContacts
}

const CUSTOMER_SUPPORT_DATA: SupportConfig[] = [
    {
        brand: 'Flyin',
        domain: 'EG',
        contacts: {
            local_calls: '0225873888',
            international_calls: '+20225873888',
            whatsapp: '+201033332689',
            email: 'customercare@flyin.com'
        }
    },
    {
        brand: 'Flyin',
        domain: 'AE',
        contacts: {
            local_calls: '+97148754550',
            international_calls: '+971525473527',
            whatsapp: '+971525473527',
            email: 'customercare@flyin.com'
        }
    },
    {
        brand: 'Cleartrip',
        domain: 'AE',
        contacts: {
            local_calls: '+97148754545',
            international_calls: '+97148754545',
            whatsapp: '+971502672234',
            email: 'customersupport@cleartrip.ae'
        }
    },
    {
        brand: 'Flyin',
        domain: 'FSA',
        contacts: {
            local_calls: '920025959',
            international_calls: '+966920025959',
            whatsapp: '+966920025959',
            email: 'customercare@flyin.com'
        }
    }
]

export const getSupportContacts = (
    brandName: 'Flyin' | 'Cleartrip',
    origin?: string
): SupportContacts | undefined => {
    const rawDomainCode = DOMAIN_COUNTRY_MAP[origin || ''] || 'AE'
    const domainCode =
        rawDomainCode === 'FEG' ? 'EG' : rawDomainCode === 'FAE' ? 'AE' : rawDomainCode

    return (
        CUSTOMER_SUPPORT_DATA.find(item => item.brand === brandName && item.domain === domainCode) ||
        CUSTOMER_SUPPORT_DATA.find(item => item.brand === brandName)
    )?.contacts
}

